// src/pages/CheckoutPage.jsx
import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { AuthContext } from "../context/AuthContext";
import PaymentButtons from "../components/PaymentButtons";

export default function CheckoutPage() {
  const { cart, clearCart } = useContext(CartContext);
  const { user } = useContext(AuthContext);

  const total = cart
    .reduce((acc, item) => acc + item.price * item.qty, 0)
    .toFixed(2);

  const handlePayment = (method) => {
    alert(
      `Payment method selected: ${method}\nOrder Total: $${total}\n(This is a frontend stub.)`
    );
    clearCart();
  };

  if (!user)
    return (
      <div className="checkout-page">
        <h2>You must be logged in to checkout</h2>
        <p>Please go back and login.</p>
      </div>
    );

  if (cart.length === 0)
    return (
      <div className="checkout-page">
        <h2>Your cart is empty</h2>
      </div>
    );

  return (
    <div className="checkout-page">

      <h1>Checkout</h1>

      <div className="checkout-section">
        <h2>Order Summary</h2>

        {cart.map((item) => (
          <div className="checkout-item" key={item.id}>
            <img src={item.img} alt={item.name} />

            <div>
              <h3>{item.name}</h3>
              <p>Qty: {item.qty}</p>
              <p>${(item.price * item.qty).toFixed(2)}</p>
            </div>
          </div>
        ))}

        <h2 className="checkout-total">Total: ${total}</h2>

        {/* Payment Buttons */}
        <PaymentButtons total={total} onPay={handlePayment} />
      </div>
    </div>
  );
}
